<template>
    <div>
        <div>
            <v-tabs
                v-model="step"
                density="compact"
                fixed-tabs
                class="rounded"
                style="background: #f4f4f4"
            >
                <v-tab value="definition">Périmètre</v-tab>
                <v-tab value="usage">Utilisation</v-tab>
            </v-tabs>
        </div>
        <div class="py-3">
            <v-text-field-filled
                v-model="companyScope.name"
                label="Nom du périmètre"
                density="compact"
                @update:model-value="
                    nameSync = $event;
                    namedScope = !!$event;
                "
            />
        </div>
        <div>
            <v-tabs-window v-model="step">
                <v-tabs-window-item :value="'definition'">
                    <div>
                        <ScopeActions
                            v-model:search="search"
                            v-bind.sync="companyScope"
                            :hide-company="hideCompany"
                            :hide-activity="hideActivity"
                            :hide-tax-system="hideTaxSystem"
                        />
                    </div>
                    <div>
                        <ScopeTable v-model:search="search" v-bind.sync="companyScope" />
                    </div>
                </v-tabs-window-item>
                <v-tabs-window-item :value="'usage'">
                    <div>
                        <ScopeParents v-model:search="search" v-bind.sync="companyScope" />
                    </div>
                </v-tabs-window-item>
            </v-tabs-window>
        </div>
    </div>
</template>

<script lang="ts">
import gql from "graphql-tag";
import { Apollo } from "@/decorators";
import OssDataTable from "../ossComponents/ossDataTable2.vue";

import ScopeActions from "./ScopeActions.vue";
import ScopeTable from "./ScopeTable.vue";
import ScopeParents from "./ScopeParents.vue";

import COMPANY_SCOPE from "@/graphql/CompanyScope.gql";
import UPSERT_COMPANY_SCOPE from "@/graphql/UpsertCompanyScope.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";

@Component({
    components: {
        OssDataTable,
        ScopeActions,
        ScopeTable,
        ScopeParents,
    },
    emits: ["scopedCompanies", "validName"],
})
export class Scope extends Vue {
    @Model({ type: String, default: "", name: "id" }) idSync: string;
    @Model({ type: String, default: "", name: "name" }) nameSync: string;

    @Prop({ default: null }) initialCompany: string;
    @Prop({ default: false }) hideCompany: boolean;
    @Prop({ default: false }) hideActivity: boolean;
    @Prop({ default: false }) hideTaxSystem: boolean;
    @Prop({ default: false }) returnScopedCompanies: boolean;
    @Prop({ default: "" }) accountingFirmId: string;

    loading = false;
    search = "";
    step = "definition";
    namedScope = false;

    beforeMount() {
        if (!this.idSync && this.initialCompany) {
            this.companyScope.clients.push(this.initialCompany);
        }
    }

    @Apollo({
        query: COMPANY_SCOPE,
        fetchPolicy: "network-only",
        variables() {
            return {
                id: this.idSync,
            };
        },
        skip() {
            return !this.idSync;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loading = loading;
            if (!loading && data) {
                if (data.companyScope.taxSystems) {
                    data.companyScope.taxSystems = data.companyScope.taxSystems.split(";");
                } else {
                    data.companyScope.taxSystems = [];
                }
                this.companyScope = data.companyScope;
            }
        },
    })
    companyScope = {
        id: "",
        name: "",
        clients: [],
        activities: [],
        taxSystems: [],
        partitionTags: [],
        accountingReviewLayout: [],
        documentRules: [],
        exportOffice: [],
        bookletTemplate: [],
        exportTheme: [],
        extensions: [],
        accountableAccountTables: [],
        bankTransactionWordingPatterns: [],
        operatingAccounts: [],
        computedIndicators: [],
    };

    activitiesCompanies = [];
    taxSystemCompanies = [];

    formatCondition(type: string) {
        switch (type) {
            case "RS_IS":
                return { taxSystem: "BIC_Simplified", taxSystemType: "IS" };
            case "RS_IR":
                return { taxSystem: "BIC_Simplified", taxSystemType: "IR" };
            case "RN_IS":
                return { taxSystem: "BIC_Normal", taxSystemType: "IS" };
            case "RN_IR":
                return { taxSystem: "BIC_Normal", taxSystemType: "IR" };
            default:
                debugger;
                return {};
        }
    }

    @Watch("idSync")
    reIntializeCompanyScope() {
        if (this.idSync === null) {
            this.companyScope = {
                id: "",
                name: "",
                clients: [],
                activities: [],
                taxSystems: [],
                partitionTags: [],
                accountingReviewLayout: [],
                documentRules: [],
                exportOffice: [],
                bookletTemplate: [],
                exportTheme: [],
                extensions: [],
                accountableAccountTables: [],
                bankTransactionWordingPatterns: [],
                operatingAccounts: [],
                computedIndicators: [],
            };
        }
    }

    @Watch("companyScope.activities", { deep: true })
    async onActivitiesChanged() {
        if (this.accountingFirmId && this.returnScopedCompanies) {
            if (this.companyScope.activities.length) {
                const activityIds = this.companyScope.activities.map((a) => a.id);

                const query = await this.$apollo.query({
                    query: gql`
                        query companiesFromActivities($accountingFirmId: ID!, $activityIds: [ID!]) {
                            companies(
                                where: {
                                    activities_some: { id_in: $activityIds }
                                    clientCompaniesToAccountingFirms_some: { id: $accountingFirmId }
                                }
                            ) {
                                id
                                name
                            }
                        }
                    `,
                    variables: {
                        activityIds: activityIds,
                        accountingFirmId: this.accountingFirmId,
                    },
                });
                if (query && query.data) {
                    this.activitiesCompanies = query.data.companies;
                } else {
                    this.activitiesCompanies = [];
                }
            } else {
                this.activitiesCompanies = [];
                // this.checkScopedCompanies()
            }
            this.$emit("scopedCompanies", this.scopedCompanies);
        }
    }

    @Watch("companyScope.name", { deep: true })
    onNameChanged() {
        this.$emit("validName", !!this.companyScope.name);
    }

    @Watch("companyScope.clients", { deep: true })
    onClientChanged() {
        this.$emit("scopedCompanies", this.scopedCompanies);
    }

    @Watch("companyScope.taxSystems", { deep: true })
    async onTaxSystemChanged() {
        if (this.accountingFirmId && this.returnScopedCompanies) {
            if (this.companyScope.taxSystems.length) {
                const orCondition = [];
                const taxSystems = [];

                this.companyScope.taxSystems.forEach((t) => {
                    if (["RS_IS", "RS_IR", "RN_IS", "RN_IR"].includes(t)) {
                        orCondition.push(this.formatCondition(t));
                        return;
                    }
                    taxSystems.push(t);
                });

                const query = await this.$apollo.query({
                    query: gql`
                        query companiesFromTaxSystems(
                            $accountingFirmId: ID!
                            $taxSystems: [CompanyTaxSystem!]
                            $orCondition: [CompanyWhereInput!]
                        ) {
                            companies(
                                where: {
                                    OR: $orCondition
                                    taxSystem_in: $taxSystems
                                    clientCompaniesToAccountingFirms_some: { id: $accountingFirmId }
                                }
                            ) {
                                id
                                name
                            }
                        }
                    `,
                    variables: {
                        orCondition: orCondition.length ? orCondition : undefined,
                        taxSystems: taxSystems,
                        accountingFirmId: this.accountingFirmId,
                    },
                });
                if (query && query.data) {
                    debugger;
                    this.taxSystemCompanies = query.data.companies;
                } else {
                    this.taxSystemCompanies = [];
                }
            } else {
                this.taxSystemCompanies = [];
            }

            this.$emit("scopedCompanies", this.scopedCompanies);
        }
    }

    get scopedCompanies() {
        const companies = [];
        if (this.companyScope.clients?.length) {
            companies.push(...this.companyScope.clients);
        }
        if (this.activitiesCompanies?.length) {
            companies.push(...this.activitiesCompanies);
        }
        if (this.taxSystemCompanies?.length) {
            companies.push(...this.taxSystemCompanies);
        }
        return companies;
    }

    async upsert(status: string = "VALIDATE", forAllAccountingCompanies: boolean = false) {
        const { id, name, clients, activities, taxSystems } = this.companyScope;
        const variables = {
            id: id || "",
            name: name,
            createAccountingCompanyOwner: { connect: { id: this.$store.state.user.company.id } },
            scopeSharingStatus: status,
            createAccountingCompany: { connect: { id: this.$store.state.user.company.id } },
            updateAccountingCompany: forAllAccountingCompanies
                ? undefined
                : { connect: { id: this.$store.state.user.company.id } },
            clientCompanyIds: clients.map((c) => ({ id: c.id })),
            clientCount: clients.length,
            activitiesIds: activities.map((a) => ({ id: a.id })),
            activityCount: activities.length,
            taxSystems: taxSystems.join(";"),
        };

        const result = await this.$apollo.mutate({
            mutation: UPSERT_COMPANY_SCOPE,
            variables,
        });

        if (result?.data?.upsertCompanyScope?.id) {
            this.idSync = result.data.upsertCompanyScope.id;
        }
        return this.idSync;
    }
}

export default toNative(Scope);
</script>
